import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { getCSSImageVars } from './utils/imageUtils';
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import ContactUs from './components/ContactUs';
import About from './components/About';
import Services from './components/Services';
import Footer from './components/Footer';

const App = () => {
  useEffect(() => {
    getCSSImageVars();
  }, []);

  return (
    <BrowserRouter>
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
